<template>
  <div class="schema-page">
    <va-inner-loading :loading="loading">
      <va-card>
        <va-card-title>JSON-LD Schema (store)</va-card-title>
        <va-card-content>
          <label class="va-form-element__label">store</label>
          <textarea
            v-model="storeValue"
            class="schema-page__textarea mb-3"
            rows="12"
          />
          <va-button color="primary" :disabled="saving" @click="save">
            {{ saving ? "Сохранение..." : "Сохранить" }}
          </va-button>
        </va-card-content>
      </va-card>
    </va-inner-loading>
  </div>
</template>

<script>
import api from "@/api/axios";

export default {
  name: "Schema",
  data() {
    return {
      storeValue: "",
      loading: true,
      saving: false,
    };
  },
  async created() {
    try {
      const response = await api.get("/admin/schema/store");
      this.storeValue =
        response.data != null ? JSON.stringify(response.data, null, 2) : "";
    } catch (error) {
      console.error("Error loading schema:", error);
      this.storeValue = "";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async save() {
      const trimmed = this.storeValue.trim();
      let parsed = null;
      if (trimmed) {
        try {
          parsed = JSON.parse(this.storeValue);
        } catch {
          this.$va?.init?.({ message: "Неверный JSON" });
          return;
        }
      }
      this.saving = true;
      try {
        await api.put("/admin/schema/store", {
          store: parsed !== undefined ? parsed : null,
        });
        if (parsed !== null && parsed !== undefined) {
          this.storeValue = JSON.stringify(parsed, null, 2);
        }
        this.$va?.init?.({ message: "Сохранено" });
      } catch (error) {
        console.error("Error saving schema:", error);
        this.$va?.init?.({
          message: error?.response?.data?.message || "Ошибка сохранения",
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.schema-page {
  &__textarea {
    display: block;
    width: 100%;
    overflow-y: auto;
    min-height: 500px;
    padding: 0.5rem;
    font-family: inherit;
    font-size: 0.875rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
  }
}
</style>
